import { isNavigationFailure, NavigationFailureType } from "vue-router";

/**
 * Vue Router 3 rejeita a promise quando um guard redireciona.
 * Isso é esperado após login e não deve aparecer como erro no console.
 */
export function ignoreRouterRedirectFailure(error) {
  if (
    isNavigationFailure(error, NavigationFailureType.redirected)
    || isNavigationFailure(error, NavigationFailureType.duplicated)
  ) {
    return;
  }

  throw error;
}
